<template>
    <VcDelimitedList
        v-if="items.length"
        :list="items"
        :limit="limit"
        separator=""
        :popover-max-width="popoverMaxWidth"
        class="redesign-tag-delimited-list"
    >
        <template #list-item="{ item }">
            <VcTag
                v-bind="tagProps"
                :label="item.label"
                :closable="closable"
                :max-content="maxContent"
                @on-close="emit('remove', item.key)"
            />
        </template>
        <template #reference="{ listLength }">
            <VcTag
                v-bind="tagProps"
                :label="`+${listLength}`"
                class="cursor-pointer"
            />
        </template>
        <template #other-content="{ list }">
            <div class="flex flex-wrap gap-1 p-2">
                <VcTag
                    v-for="tag in list"
                    :key="tag.key"
                    v-bind="tagProps"
                    :label="tag.label"
                    :closable="closable"
                    :max-content="overflowMaxContent"
                    @on-close="emit('remove', tag.key)"
                />
            </div>
        </template>
    </VcDelimitedList>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcDelimitedList, VcTag, type VcTagColorType } from '@voicenter-team/voicenter-ui-plus'

type RedesignTagDelimitedItem = {
    key: string | number
    label: string
}

const props = withDefaults(defineProps<{
    items: RedesignTagDelimitedItem[]
    limit?: number
    closable?: boolean
    maxContent?: string | number
    overflowMaxContent?: string | number
    popoverMaxWidth?: number
    color?: VcTagColorType
    compact?: boolean
    filled?: boolean
    borderless?: boolean
    square?: boolean
    labelClass?: string
}>(), {
    limit: 2,
    closable: false,
    maxContent: 'auto',
    overflowMaxContent: 'auto',
    popoverMaxWidth: 350,
    color: 'secondary',
    compact: true,
    filled: false,
    borderless: false,
    square: false
})

const emit = defineEmits<{
    (e: 'remove', key: string | number): void
}>()

const tagProps = computed(() => ({
    color: props.color,
    compact: props.compact,
    filled: props.filled,
    borderless: props.borderless,
    square: props.square,
    labelClass: props.labelClass
}))
</script>

<style lang="scss">
/* Fills parent height when parent flex uses items-stretch */
.redesign-tag-delimited-list {
    .vc-delimited-list-container,
    .vc-delimited-list-item-wrapper,
    .vc-delimited-list-container > *,
    .vc-tag {
        height: 100%;
    }
}
</style>
